import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AppTokenService,
  AuthAccessTokenDetails,
  OauthAEMConfig,
  UserDataService
} from '@com-delta-idp/mnx-oauth';
import {
  ApiBuilder,
  AppConfigService,
  handleError,
  HttpHeadersPayload,
  HttpRequestMethods,
  IDP_APPS
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { filter, shareReplay, switchMap } from 'rxjs/operators';
import { v4 as uuid } from 'uuid';
import { UrlUtil } from '../../config/urlutil';
import {
  DEFAULT_TIMEOUT,
  HTTP_HEADERS,
  MyTripEndpointKeys,
  SHARED_UPCOMING_TRIP
} from '../../model/enums/most-upcoming-trips.enums';
import { TodaysTrip } from '../../model/today-trip.model';

@Injectable({
  providedIn: 'root'
})
export class TodaysTripAwsService {
  todaysTrip$!: Observable<TodaysTrip>;
  headerInfo: HttpHeadersPayload = {
    'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: ''
  };

  constructor(
    private appToken: AppTokenService,
    private appConfigService: AppConfigService,
    private userDataService: UserDataService,
    private http: HttpClient,
    private urlUtil: UrlUtil
  ) {}

  _errorHandler = handleError.bind(this);

  getTodayTrip = (skymilesNumber: string): Observable<TodaysTrip> => {
    if (this.todaysTrip$) {
      return this.todaysTrip$;
    } else {
      this.todaysTrip$ = this.initAwsAPI(skymilesNumber).pipe(shareReplay());
      return this.todaysTrip$;
    }
  };

  initAwsAPI(skymilesNumber: string): Observable<TodaysTrip> {
    return this.userDataService.getAuthConfigContent().pipe(
      filter((config: OauthAEMConfig) => !!config),
      switchMap((config: OauthAEMConfig) => {
        const authCopy: OauthAEMConfig = {
          ...config,
          SCOPE_VALUE_RM: `${config.SCOPE_VALUE} ${config.SAVED_SEARCH_GRAPHQL_SCOPE_VALUE}`,
          CLIENT_ID_VALUE: config['HEADER_CLIENT_ID_VALUE']
        };
        return this.appToken.getAppToken(authCopy).pipe(
          switchMap((token: AuthAccessTokenDetails) => {
            if (token?.access_token) {
              const event = new CustomEvent('header-token', {
                bubbles: true
              });
              document.dispatchEvent(event);
            }

            this.headerInfo[
              'Authorization'
            ] = `${HTTP_HEADERS.BEARER} ${token.access_token}`;

            const payload = this.urlUtil.toObjQueryString({
              skymilesNbr: skymilesNumber,
              nmbrOfTrips: '1',
              transactionId: `${HTTP_HEADERS.TODAYS_TRIP} ${uuid()}`
            });

            return new ApiBuilder<string, TodaysTrip>(
              this.http,
              this.appConfigService
            )
              .app(IDP_APPS.HEADER)
              .endpointKey(MyTripEndpointKeys.GET_TODAYS_TRIP_AWS_URL)
              .method(HttpRequestMethods.POST)
              .payload(payload)
              .httpHeaders(this.headerInfo)
              .errorHandler(this._errorHandler)
              .timeOut(DEFAULT_TIMEOUT)
              .library(SHARED_UPCOMING_TRIP)
              .create();
          })
        );
      })
    );
  }
}
